module.exports = __webpack_public_path__ + "static/media/newheader.c264e4d3.png";